import React from 'react';
import { useClassName } from 'common/hooks';
import './experiences-begin-here.less';
import {
  DesktopOnly,
  getContentfulField,
  unwrapContentfulFields,
} from 'common/components';
import { AnimatedText } from '../AnimatedText/AnimatedText';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { usePagination } from 'public/screens/Home/Components/usePagination';
import SectionLink from 'public/screens/CustomLandingPage/Components/SectionLink';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

export const ExperiencesBeginHere = ({ venue, events }) => {
  const className = useClassName('ExperiencesBeginHere');
  const pagination = usePagination({});
  const tertiaryColor = getContentfulField(venue.parkScreen?.tertiaryColor);

  const slides = events
    .filter((event) => event?.venue?.parkScreenId === venue?.parkScreenId)
    .map((event) => {
      const { images } = event;
      if (images.length === 0) return null;
      const assets = getContentfulField(images);

      const { url } = getContentfulField(assets[0].fields.file);

      return {
        asset: url,
        link: `/events/${event.slug}`,
      };
    })
    .filter(Boolean);

  const title =
    getContentfulField(venue.parkScreen?.experiencesBeginHereTitle) ||
    'Experiences Begin Here';
  const description =
    getContentfulField(venue.parkScreen?.experiencesBeginHereDescription) ||
    null;
  const rawCta = getContentfulField(venue.parkScreen?.experiencesBeginHereCta);
  const cta = rawCta ? unwrapContentfulFields(rawCta) : null;

  if (!events || events.length === 0) return null;

  return (
    <div
      className={className('container')}
      style={{ backgroundColor: tertiaryColor }}>
      <div className={className('header')}>
        <h2 className={className('header__title')}>
          <AnimatedText text={title} />
        </h2>
        <div className={className('header__description')}>
          {documentToReactComponents(description) ||
            'Discover the most unique and exciting experiences in the world.'}
        </div>
        {cta && (
          <DesktopOnly>
            <SectionLink component={cta} refs={{}} />
          </DesktopOnly>
        )}
      </div>
      <div className={className('events')}>
        <Swiper
          {...pagination}
          slidesPerView="auto"
          centeredSlides={slides.length !== 2}
          spaceBetween={28}
          modules={[Pagination]}
          className={className('events__carousel')}>
          {slides.map((slide, index) => {
            const { asset } = slide;

            return (
              <SwiperSlide
                key={index}
                className={className('events__carousel__slide')}>
                <a href={slide.link}>
                  <img src={asset} alt="event" />
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </div>
  );
};
